var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52827 3.5286C5.76859 3.28828 6.14675 3.26979 6.40827 3.47314L6.47108 3.5286L10.4711 7.5286C10.7114 7.76892 10.7299 8.14707 10.5265 8.4086L10.4711 8.47141L6.47108 12.4714C6.21073 12.7318 5.78862 12.7318 5.52827 12.4714C5.28795 12.2311 5.26946 11.8529 5.47281 11.5914L5.52827 11.5286L9.05634 8L5.52827 4.47141C5.28795 4.23108 5.26946 3.85293 5.47281 3.5914L5.52827 3.5286Z",
    fill: "#059669"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.9846b04b9430501131d90412e4a115b1.svg";
export { ForwardRef as ReactComponent };